import { CheckerboardMinusIcon } from './CheckerboardMinusIcon';

/**
 * author: Michael Irigoyen
 * id 925C7A7F-E7D0-4260-B131-D96FF2F7B8DB
 * name checkerboard-minus
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard-minus.svg
 * tags
 * - Geographic Information System 
 */
export const RasterMinusIcon = CheckerboardMinusIcon;
export default RasterMinusIcon